import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { getAuth, signInWithEmailAndPassword } from '@angular/fire/auth';
import { FirebaseApp } from '@angular/fire/app';

import { LoginService } from 'src/app/services/login/login.service';
import { StorageService } from 'src/app/services/common/storage';
import { Action, Store } from '@ngrx/store';
import { AppState, selectAuthState } from 'src/app/store/app.states';
import { LogInFailure, LogInSuccess } from 'src/app/store/actions/auth.actions';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';
import { take } from 'rxjs/operators';
import { IEtudiantAdvanced, ITeacher } from 'src/app/interfaces/etudiant';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public showSpinner: boolean;
  public submitted: boolean = false;
  public submitFormName: string;
  public state: any;
  public workspace: { labels: ["Espace étudiant", "Espace Enseignant"], id: 0 | 1, nextId: number } =
    {
      labels: ["Espace étudiant", "Espace Enseignant"],
      id: 0,
      nextId: 1
    };
  public message: string;
  public loginForm: FormGroup;
  public showSpinnerStudent: boolean;
  public checkBox = "2023";

  constructor(public userService: UserService, private afApp: FirebaseApp, protected local: StorageService,
    private readonly router: Router,
    private formbuilder: FormBuilder,
    private loginService: LoginService,
    private store: Store<AppState>,
    public storage: StorageService) {


  }

  public changeWorkSpace(): void {

    console.log(this.workspace)
    this.workspace =
    {
      labels: ["Espace étudiant", "Espace Enseignant"],
      id: this.workspace.id === 0 ? 1 : 0,
      nextId: this.workspace.nextId === 1 ? 0 : 1,
    };
  }

  ngOnInit(): void {

    this.loginForm = this.formbuilder.group({
      promotion: ['2023'],

      email: new FormControl(
        '',
        [
          Validators.required,
          Validators.email,
        ]),
      password: new FormControl(
        '',
        [
          Validators.required,
        ]),


      remember: new FormControl(
        ''),
    });

    this.store.select(selectAuthState).subscribe(state => {
      this.state = state;
      this.showSpinnerStudent = false;
    })
  }


  /**
   * 
   * @param auth 
   * @param email 
   * @param password 
   */
  private async logIn(email, password) {
    const auth = getAuth(this.afApp);
    try {

      const { user } = (await signInWithEmailAndPassword(auth, email, password));

      this.loginService.isAdmin(user.uid).then(isAdmin => {

        this.showSpinner = false;
        this.showSpinnerStudent = false;

        if (this.workspace.id == 0 && !isAdmin) {
          this.studentDispatch();
          return;
        }

        else if (this.workspace.id == 1 && isAdmin) {
          this.teacherDispatch();
          return;
        }
        else {
          this.store.dispatch(new LogInFailure(null));
        }
      })

    } catch (error) {
      this.showSpinner = false;
      this.store.dispatch(new LogInFailure(null));
    }
  }

  private studentDispatch() {

    this.userService.getStudentByEmail(this.loginForm.value.email)
      .then((etudiant: IEtudiantAdvanced) => {
        etudiant.isAdmin = false;
        etudiant.isAuthenticated = true;
        etudiant.type = 0;
        this.store.dispatch(this.createInstanceSuccess(etudiant));
        this.router.navigateByUrl("/student/training");
        this.loginForm.reset();

      }, error => {
        this.store.dispatch(new LogInFailure(null));
      });
  }

  private createInstanceSuccess(userUpdated: IEtudiantAdvanced | ITeacher): Action {
    this.local.logoutSubject.next(true);
    const successAction = new LogInSuccess(userUpdated, this.local)
    successAction.localStorage.setItem('isAuthenticated', true);
    successAction.localStorage.setItem('user', JSON.stringify(userUpdated));
    successAction.localStorage.setUserItem(JSON.stringify(userUpdated));
    successAction.localStorage.setItem('admin', userUpdated.type);
    return successAction
  }

  private teacherDispatch() {

    const userUpdated = this.loginForm.value;
    userUpdated["type"] = 1;
    userUpdated["isAdmin"] = true;
    userUpdated["isAuthenticated"] = true;
    userUpdated["password"] = "";


    this.store.dispatch(this.createInstanceSuccess(userUpdated));
    this.router.navigateByUrl("/studies");
    this.loginForm.reset();
  }

  /**
   * Login for teacher
   * @returns 
   */
  onSubmit() {
    this.showSpinner = true;
    console.log(this.loginForm)
    if (this.loginForm.invalid) {
      return;
    }
    const { email, password } = this.loginForm.value;
    this.logIn(email, password);
  }

}
